/**
 * Class strings shared by several components so the system stays consistent. Scanned by
 * Tailwind through `@source "../lib"` in globals.css.
 */

/** Keyboard focus on a standalone control: the ink ring, 2 px wide, 2 px off the edge. */
export const focusRing =
  "outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background";

/** Focus for dense rows (menus, tabs, table rows) where an offset would collide with neighbours. */
export const focusRingTight = "outline-none focus-visible:ring-2 focus-visible:ring-ring";

/** Focus on the rail: its own ring token, offset from the rail's paper. */
export const focusRingSidebar =
  "outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar";

/**
 * Text-entry controls (input, textarea, select trigger): page fill, 1 px `input` edge
 * (3:1 against the page), 4 px radius, the ink focus ring, a destructive edge when invalid.
 */
export const fieldControl = [
  "rounded-md border border-input bg-background text-foreground transition-[color,border-color,box-shadow] duration-150 ease-out-quiet",
  "placeholder:text-muted-foreground",
  focusRing,
  "aria-invalid:border-destructive aria-invalid:ring-destructive/30",
  "disabled:cursor-not-allowed disabled:opacity-50",
].join(" ");

/** A one-line field, 36 px tall; 16 px type on phones so iOS does not zoom. */
export const fieldLine = `${fieldControl} h-9 w-full min-w-0 px-3 py-1 text-base md:text-sm`;

/**
 * Overlays (menus, popovers, dialogs, the command palette, tooltips): the popover surface with
 * the 1 px edge and the tight drop of `shadow-overlay`. They enter in 150 ms on the quiet ease
 * and leave at once.
 */
export const overlaySurface =
  "bg-popover text-popover-foreground rounded-lg shadow-overlay data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:duration-150 data-[state=open]:ease-out-quiet";

/**
 * The scrim behind dialogs and sheets: a wash of carbon over paper, and in dark the carbon
 * paper itself drawn over the page, never pure black.
 */
export const scrim =
  "fixed inset-0 z-50 bg-foreground/25 dark:bg-background/80 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:duration-150 data-[state=open]:ease-out-quiet";
